<template>
  <div class="container">
    <div class="row">
      <img src="../assets/WhtBrd-bars.png" class="logo mt-1 mb-4">
      
      <form class="form col-10 offset-1">
          <h3 class="center">Sign Up</h3>
          <input type="text" v-model="name" class="form-control mt-2" :class="[validClass.name]" placeholder="Name i.e. 'Darth Vader'" />
          <input type="text" v-model="email" class="form-control mt-2" :class="[validClass.email]" placeholder="Email" />
          <label class="mt-2">Choose a 4 digit PIN</label>
          <div class="pin-group"> 
            <input type="text" v-model="pin1" ref="pin1" @keyup="pinInput(1)" class="form-control pinbox" :class="[validClass.pin]" maxlength="1" />
            <input type="text" v-model="pin2" ref="pin2" @keyup="pinInput(2)" class="form-control pinbox ml-1 mr-1" :class="[validClass.pin]" maxlength="1" />
            <input type="text" v-model="pin3" ref="pin3" @keyup="pinInput(3)" class="form-control pinbox mr-1" :class="[validClass.pin]" maxlength="1" />
            <input type="text" v-model="pin4" ref="pin4" @keyup="pinInput(4)" class="form-control pinbox" :class="[validClass.pin]" maxlength="1" />
          </div> 
          
          <div class="form-group mt-2">
            <label>Optional</label>
            <input type="text" v-model="boxName" class="form-control" placeholder="Box Name" />
            <input type="text" v-model="boxCityState" class="form-control mt-2" placeholder="Box City and State" />
          </div>          
          <button class="btn btn-outline-primary btn-block mt-2" @click.prevent="signup">Sign Up</button>
          <p class="center mt-2">Go back to <router-link to="/login">Login</router-link></p>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import 'firebase/firestore'


export default {
  name: 'login',
  data () {
    return {
      db: "",
      email: "",
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      name: "",
      boxName: "",
      boxCityState: "",
      validClass: {
        pin: "valid",
        name: "valid",
        email: "valid"
      },
      formErrors: []
    }
  },
  created () {
    //this.db = firebase.firestore()
  },
  computed: {
    password: function () {
      return `${this.pin1}${this.pin2}${this.pin3}${this.pin4}-WhtBrd`
    }
  },
  methods: {
      pinInput: function (pin) {
        //console.log(this.$refs[`pin${pin}`].value)
        if(this.$refs[`pin${pin}`].value.length === 1 && pin != 4) {
          this.$refs[`pin${pin+1}`].focus()
        }

      },
      isValid: function () {
        //reset all values
        this.formErrors = []
        this.validClass.name = 'valid'
        this.validClass.email = 'valid'
        this.validClass.pin = 'valid'

        if(this.name == ""){
          this.validClass.name = "is-invalid"
          this.formErrors.push("Don't be silly...the 'Name' field can not be blank.")
        } 
        if (this.email == ""){
          this.validClass.email = "is-invalid"
          this.formErrors.push("Sorry, 'email' must ba a valid email address.")
        } 
        if (this.pin1 == "" || this.pin2 == "" || this.pin3 == "" || this.pin4 == ""){
          this.pin4 = ""
          this.pin3 = ""
          this.pin2 = ""
          this.pin1 = ""
          this.validClass.pin = "is-invalid"
          this.formErrors.push("Woops, You must enter a 4 digit numeric PIN, Try again!")
        }

        if (this.formErrors.length == 0) {
          return true
        } else {
          return false
        }

      },
      signup: function () {
        let isValid = this.isValid()
        
        if(isValid){

            firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
            .then(user => {
                this.$store.state.db.doc(`users/${user.uid}`).set({
                  displayName : this.name,
                  email : this.email,
                  boxName : this.boxName,
                  boxCityState : this.boxCityState,
                  bgColor: ""
                })
                .then(() => {
                  console.log('User creaated successfully. Added to Firestore!. Redirecting to home...')
                  this.$store.commit('setAuthUser')
                  this.$store.state.db.collection('users').doc(user.uid).get()
                  .then(doc => {
                    this.$store.commit('setUser', doc.data())
                    this.$notify({group: 'note', text: 'Sign up successful!', type: 'signUp-success' })
                    this.$router.replace("home")
                  })
              
                })
                
            }, err => {
                //alert(`Woops: ${err.message}`)
                this.$notify({group: 'note', title: "Woops", text: err.message, type: 'error', duration: 4500, })
                console.log(`Woops: ${err.message}`)
            })

        } else {
          let errorTxt = ""
          this.formErrors.forEach((err,index) => {
            errorTxt += `${index+1}. ${err}<br/>`
          })

          this.$notify({
            group: 'note',
            text: errorTxt,
            type: 'error'
          })
        }
        
          
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center {
  text-align: center;
}
.logo {
  width:30%;
  height: 30%;
  display:block;
  margin:auto;
}

.pin-group {
    display: flex;
    justify-content: center;
    align-items: center
}
.pinbox {
    padding: 10px; 
    width: 60px;
    height: 60px;
    text-align: center;
    font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/signup.vue